const useSearch = (text = "", searchItems = []) => {
  const text1 = text?.split(" ")?.[0] || "";
  const text2 = text?.split(" ")?.[1] || "";

  const filtered1 = searchItems
    ?.filter(
      (o) =>
        o?.categoryName
          ?.toLowerCase()
          ?.includes(text1?.trim()?.toLowerCase()) ||
        o?.subCategoryName
          ?.toLowerCase()
          ?.includes(text1?.trim()?.toLowerCase()) ||
        o?.brandName?.toLowerCase()?.includes(text1?.trim()?.toLowerCase()) ||
        (Array.isArray(o?.itemColorNames) &&
          [...o?.itemColorNames]
            ?.join(",")
            ?.toLowerCase()
            ?.includes(text1?.trim()?.toLowerCase()))
    )
    ?.filter(
      (o) =>
        o?.categoryName
          ?.toLowerCase()
          ?.includes(text2?.trim()?.toLowerCase()) ||
        o?.subCategoryName
          ?.toLowerCase()
          ?.includes(text2?.trim()?.toLowerCase()) ||
        o?.brandName?.toLowerCase()?.includes(text2?.trim()?.toLowerCase()) ||
        (Array.isArray(o?.itemColorNames) &&
          [...o?.itemColorNames]
            ?.join(",")
            ?.toLowerCase()
            ?.includes(text2?.trim()?.toLowerCase()))
    );

  return filtered1 || [];
};

export default useSearch;
